/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cli_ToolsInputs */

const en_cli_tools = /** @type {(inputs: Cli_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CLI Tools`)
};

const fr_cli_tools = /** @type {(inputs: Cli_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outils CLI`)
};

const de_cli_tools = /** @type {(inputs: Cli_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CLI-Tools`)
};

const it_cli_tools = /** @type {(inputs: Cli_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strumenti CLI`)
};

const ru_cli_tools = /** @type {(inputs: Cli_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Инструменты командной строки`)
};

const es_cli_tools = /** @type {(inputs: Cli_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Herramientas CLI`)
};

const zh_cn2_cli_tools = /** @type {(inputs: Cli_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`命令行工具`)
};

const ja_cli_tools = /** @type {(inputs: Cli_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CLIツール`)
};

const hi_cli_tools = /** @type {(inputs: Cli_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CLI उपकरण`)
};

const pt_pt2_cli_tools = /** @type {(inputs: Cli_ToolsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ferramentas de linha de comando`)
};

/**
* | output |
* | --- |
* | "CLI Tools" |
*
* @param {Cli_ToolsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const cli_tools = /** @type {((inputs?: Cli_ToolsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cli_ToolsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_cli_tools(inputs)
	if (locale === "de") return de_cli_tools(inputs)
	if (locale === "it") return it_cli_tools(inputs)
	if (locale === "ru") return ru_cli_tools(inputs)
	if (locale === "es") return es_cli_tools(inputs)
	if (locale === "zh-CN") return zh_cn2_cli_tools(inputs)
	if (locale === "ja") return ja_cli_tools(inputs)
	if (locale === "hi") return hi_cli_tools(inputs)
	if (locale === "pt-PT") return pt_pt2_cli_tools(inputs)
	return en_cli_tools(inputs)
});